import { useState, type ReactNode } from "react";
import { Platform } from "@-/com.npmjs.react-native";
import {
  PrimaryControlsStripBackContext,
  createPrimaryControlsStripBackRegistry,
  type PrimaryControlsStripBackRegistry,
} from "#primary-controls-strip-back-context";

const isWeb = Platform.OS === "web";

function PrimaryControlsStripBackProviderNative({ children }: { children: ReactNode }) {
  const [registry] = useState<PrimaryControlsStripBackRegistry>(() =>
    createPrimaryControlsStripBackRegistry(),
  );
  return (
    <PrimaryControlsStripBackContext.Provider value={registry}>
      {children}
    </PrimaryControlsStripBackContext.Provider>
  );
}

/** Wraps the subtree containing both the back-control lanes (`usePrimaryControlsStripBackGate`) and `PrimaryControlsStripBack` callsites. */
export function PrimaryControlsStripBackProvider({ children }: { children: ReactNode }) {
  return isWeb ? (
    <>{children}</>
  ) : (
    <PrimaryControlsStripBackProviderNative>{children}</PrimaryControlsStripBackProviderNative>
  );
}
